// extracted by mini-css-extract-plugin
module.exports = {"unitTag":"styles_unitTag__1bxg-","tagPadding":"styles_tagPadding__16nck","tagRemove":"styles_tagRemove__1hJn_","unitName":"styles_unitName__1Q---"};